// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

defineWellKnownSymbol('replaceAll');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.replace-all.js
// module id = 939
// module chunks = 3